/**
 * Route template functions for navigation
 * Used by parent to generate navigation routes
 */
export const ROUTE_TEMPLATES = {
  DASHBOARD: (appId: string) => `/app/${appId}/dashboard`,
  CREATE_ACCOUNT: (appId: string) => `/createAccount/${appId}`,
  PRICING: (appId: string) => `/app/${appId}/pricing`,
} as const;